import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import moment from "moment";
import { isChrome } from "react-device-detect";
import "./Graph.css";
import Colors from "../../../assets/Color/Colors";
import {GlobalScreens} from "../../../utils/globalConstant";
import {convert} from "../../../locale/translateText";

try {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );
} catch (e) {}

const actual = [
  { time: "2022-07-01T11:00:00.000Z", price: 61.11875 },
  { time: "2022-06-01T12:00:00.000Z", price: 27.347499999999993 },
  { time: "2022-06-01T14:00:00.000Z", price: 3.45 },
  { time: "2022-07-01T15:00:00.000Z", price: 17.45 },
];

export const options = {
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },

    tooltip: {
      callbacks: {
        title: function (context) {
          return context[0].raw.time;
        },
      },
    },
  },
  scales: {
    y: {
      type: "linear",
      display: true,
      position: "left",
      min: 0,
      max: 100,
      grid: {
        display: true,
      },
    },
    responsive: true,
    x: {
      display: false,
      grid: {
        display: false,
      },
    },
  },
  parsing: {
    xAxisKey: "timeIndex",
    yAxisKey: "price",
  },
};

const Chart = ({ graphData = [], isNo }) => {
  //const [isYesSelected, setIsYesSelected] = useState(true);
  const [isChrome77, setIsChrome77] = useState(null);

  useEffect(() => {
    if (isChrome) {
      try {
        Object.getPrototypeOf(
          new Proxy(Object.create(null), {
            getPrototypeOf(target) {
              return Reflect.getPrototypeOf(target);
            },
          })
        );
        setIsChrome77(false);
      } catch (e) {
        setIsChrome77(true);
      }
    }
  }, []);
  const data = {
    datasets: [
      !isNo
        ? {
            pointRadius: 0,
            label: convert("Yes"),
            data: graphData?.map((item, index) => {
              const time = moment
                .utc(item.time)
                .local()
                .format("DD/MM/YY hh:mm a");
              return {
                ...item,
                ...{
                  time: time,
                  timeIndex: index.toString(),
                  price: item.price.toFixed(2),
                },
              };
            }),
            borderColor: GlobalScreens.Event.yesBtnTxt,
            backgroundColor: GlobalScreens.Event.yesBtnTxt,
            yAxisID: "y",
            tension: 0.1,
          }
        : {
            pointRadius: 0,
            label: convert("No"),
            data: graphData?.map((item, index) => {
              const time = moment
                .utc(item.time)
                .local()
                .format("DD/MM/YY hh:mm a");
              return {
                ...item,
                ...{
                  time: time,
                  timeIndex: index.toString(),
                  price: (100 - item.price).toFixed(2),
                },
              };
            }),
            borderColor: GlobalScreens.Event.noBtnTxt,
            backgroundColor: GlobalScreens.Event.noBtnTxt,

            tension: 0.1,
          },
    ],
  };

  const checkBrowser = () => {
    let isBrowserCompatible = true;

    if (isChrome) {
      if (isChrome77 === null) {
        try {
          Object.getPrototypeOf(
            new Proxy(Object.create(null), {
              getPrototypeOf(target) {
                return Reflect.getPrototypeOf(target);
              },
            })
          );
        } catch (e) {
          isBrowserCompatible = false;
        }
      } else {
        isBrowserCompatible = !isChrome77;
      }

      if (!window?.ResizeObserver || !isBrowserCompatible) return false;
    } else {
      if (!window?.ResizeObserver) return false;
    }
    return true;
  };

  const handleCheckbox = (value) => {
    setYesGraphSet(value);
  };
  return (
    <div
      style={{ display: "flex", flexDirection: "column" }}
      className="event-graph-mob"
    >
      <div
        style={{
          width: "100%",
        }}
      >
        {checkBrowser() ? (
          <Line options={options} data={data} />
        ) : (
          <div className="parentBrowserInfo-blk">
            {/*<img src={info_black()} style={{ height: "20px", width: "20px" }} />*/}
            <p className="browserInfo-title">Unable to fetch graph!</p>
            <p className="browserInfo-subtitle">
              Some of the fetaures of TradeX will not work for your device.
              Please update your chrome/safari browser in order to acess full
              features of TradeX
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chart;
